import { cn } from "@/lib/utils"
import type { ReactNode } from "react"

interface GradientTextProps {
  children: ReactNode
  className?: string
  as?: keyof JSX.IntrinsicElements
}

export function GradientText({ children, className, as: Component = 'span' }: GradientTextProps) {
  return (
    <Component
      className={cn(
        "bg-gradient-to-r from-vibrant-purple to-electric-blue bg-clip-text text-transparent",
        className
      )}
    >
      {children}
    </Component>
  )
}
